import Login from "./login";
import timezonesAll from "timezones";
import _request from "actions/_request";
import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import { Alert, Box, Button, Snackbar, Typography } from "@mui/material";

export default class Signup extends Login {
    constructor(props) {
        super(props);

        this.titles = {
            rightTitle: "login",
            mainTitle: "signupMain",
            smallTitle: "signupSmall",
        };

        const userTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const timezone = timezonesAll.find(it => it.id === userTz) ? userTz : "-1";

        this.state = {
            ...this.state,
            timezones: [{ id: "-1", name: this.tr("selectTimezone") }, ...timezonesAll],
            timezone,
            fullName: "",
            passwordConfirm: "",
            alertOpen: false,
            isSignedUp: false,
        };

        this.passInvalidText = this.tr("passInvalid");
    }

    validatePassMatch(value) {
        return this.state.password === value;
    }

    isButtonDisabled() {
        const { timezone, fullName, email, password, passwordConfirm } = this.state;

        return !(fullName.length > 5 && email.length > 5 && password.length > 2 && passwordConfirm.length > 2 && timezone !== "-1");
    }

    async mainButtonClick() {
        const { timezone, fullName, email, password, passwordConfirm } = this.state;

        if (!this.validateEmail(email))
            return false;

        if (!this.validatePassMatch(passwordConfirm))
            return this.setState({ error: { key: "passwordConfirm", text: this.passInvalidText, validator: this.validatePassMatch.bind(this) } });

        const resp = await _request.auth.loading(async () => {
            return await _request.auth.signup({ timezone, full_name: fullName, email, password });
        });

        if (resp?.isOk)
            this.setState({
                alertOpen: true,
                isSignedUp: true,
                mainTitle: this.tr("signupSuccess")
            });
    }

    handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        this.setState({ alertOpen: false });
    };

    goToLogin = () => {
        window.location.href = "/";
    };

    renderForm() {
        const { timezone, timezones, alertOpen, isSignedUp } = this.state;

        return (
            <>
                {!isSignedUp && (
                    <Box className="flex column gap24 relative">
                        {this.insertInput({
                            key: "fullName",
                            placeholder: "fullName",
                            icon: <ContactPageOutlinedIcon sx={{ color: '#636678' }} />,
                            props: {
                                type: "text",
                                autoFocus: true,
                            }
                        })}
                        {this.insertEmail("email", "", "emailAddress", false)}
                        <Box className="flex gap24 colOnSmall">
                            {this.insertPassword("password", "", "password")}
                            {this.insertPassword("passwordConfirm", "", "confirm")}
                        </Box>
                        {this.insertSelect(timezone, timezones, this.changeInputValue.bind(this, "timezone"))}
                        {this.insertButton("signup")}
                        {this.insertSocialButtons()}
                    </Box>
                )}

                {isSignedUp && (
                    <Box className="flex column alignCenter" sx={{ marginTop: '20px' }}>
                        <Typography variant="h6" sx={{ marginBottom: '20px', color: 'green' }}>
                            {this.tr("signupComplete")}
                        </Typography>
                        <Button
                            className="buttonNew"
                            onClick={this.goToLogin}
                        >
                            {this.tr("goToLogin")}
                        </Button>
                    </Box>
                )}

                <Box sx={{ position: 'relative' }}>
                    <Snackbar
                        open={alertOpen}
                        autoHideDuration={10000}
                        onClose={this.handleCloseAlert}
                        sx={{ position: 'absolute', bottom: '-100px!important', left: 'auto!important' }}
                    >
                        <Alert
                            onClose={this.handleCloseAlert}
                            severity="info"
                            sx={{ width: '100%', backgroundColor: '#4caf50', color: '#fff' }}
                        >
                            {this.tr("signupVerify")}
                        </Alert>
                    </Snackbar>
                </Box>
            </>
        );
    }
}
